import React from 'react';
import { defaultTemplate } from 'core/hoc';

// we have to pass selectedValue within object (threeState) because it passes as reference
const ThreeStateToggle = ({ threeState, first, second, third, t }) => {
	return (
		<div>
			<div className="three-state-toggle__wrap">
				<div className="three-state-toggle__item">
					<input
						id="first"
						name="three-state toggle"
						type="radio"
						className="three-state-toggle"
						onChange={() => (threeState.selectedValue = first.value)}
						checked={threeState.selectedValue === first.value}
					/>
					<label htmlFor="first">{t(first.translation)}</label>
				</div>
				<div className="three-state-toggle__item">
					<input
						id="second"
						name="three-state toggle"
						type="radio"
						className="three-state-toggle"
						onChange={() => (threeState.selectedValue = second.value)}
						checked={threeState.selectedValue === second.value}
					/>
					<label htmlFor="second">{t(second.translation)}</label>
				</div>
				<div className="three-state-toggle__item">
					<input
						id="third"
						name="three-state toggle"
						type="radio"
						className="three-state-toggle"
						onChange={() => (threeState.selectedValue = third.value)}
						checked={threeState.selectedValue === third.value}
					/>
					<label htmlFor="third">{t(third.translation)}</label>
				</div>
			</div>
		</div>
	);
};

export default defaultTemplate(ThreeStateToggle);



// WEBPACK FOOTER //
// ./src/common/utils/ThreeStateToggle.jsx